var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOOR_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    fill: "#7A97F4",
    d: "M298.8,370c-47.7,0-86.4,10.1-86.4,22.4c0,12.4,38.7,22.5,86.4,22.5 c42.5,0,77.9-8,85.1-18.5c0,0,0,0,0,0c0.9-1.3,1.3-2.6,1.3-3.9C385.2,380.1,346.5,370,298.8,370z M298.8,395.6 c-27.5,0-49.7-3.3-49.7-7.4c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c1.9-3.8,23.4-6.8,49.5-6.8 c25.2,0,46,2.8,49.2,6.4c0.3,0.3,0.4,0.6,0.4,0.9c0,0,0,0.1,0,0.1C348.5,392.3,326.2,395.6,298.8,395.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FLOOR_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_157_",
    fill: "#7A97F4",
    d: "M195.2,377.1H112c-2.1,0-4.2,0.7-5.9,2l-32,25.1c-1.5,1.2-0.7,3.6,1.2,3.6h87.9 c2.2,0,4.4-0.9,6-2.4l26.9-26C197,378.6,196.4,377.1,195.2,377.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "FLOOR_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    fill: "#7A97F4",
    d: "M525.3,377.1H442c-2.1,0-4.2,0.7-5.9,2l-32,25.1c-1.5,1.2-0.7,3.6,1.2,3.6h87.9 c2.2,0,4.4-0.9,6-2.4l26.9-26C527.1,378.6,526.5,377.1,525.3,377.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    fill: "#FF97C9",
    d: "M298.8,365.9c-47.7,0-86.4,10.1-86.4,22.4c0,12.4,38.7,22.5,86.4,22.5 c42.5,0,77.9-8,85.1-18.5c0,0,0,0,0,0c0.9-1.3,1.3-2.6,1.3-3.9C385.2,376,346.5,365.9,298.8,365.9z M298.8,391.5 c-27.5,0-49.7-3.3-49.7-7.4c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c1.9-3.8,23.4-6.8,49.5-6.8 c25.2,0,46,2.8,49.2,6.4c0.3,0.3,0.4,0.6,0.4,0.9c0,0,0,0.1,0,0.1C348.5,388.2,326.2,391.5,298.8,391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    fill: "#F774B9",
    d: "M383.9,392.3c-7.2,10.5-42.5,18.5-85.1,18.5c-47.7,0-86.4-10.1-86.4-22.5 c0,0,15,18.1,83.4,18.1C354.6,406.5,378.3,395.4,383.9,392.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    fill: "#F774B9",
    d: "M348,383.1c-3.3-3.6-24.1-6.4-49.2-6.4c-26.2,0-47.6,3-49.5,6.8c0.9-2.2,6.9-9.8,49.5-9.8 C338,373.7,346.3,380.5,348,383.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "FOUR_SHADOW_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    fill: "#273D7A",
    d: "M195.9,377.1l-17.5-125.2c-0.2-1.3-1.3-2.3-2.7-2.3h-23.6c-1.6,0-2.9,1.4-2.7,3.1l5.9,47.3 c0.2,1.9-1.2,3.5-3.1,3.5h-27c-1.7,0-3.1-1.3-3.2-3l-2.2-48.2c-0.1-1.5-1.3-2.6-2.7-2.6H95c-1.6,0-2.8,1.3-2.7,2.8l3,82.4 c0.1,2.6,2.3,4.7,4.9,4.7h60.1l4.7,37.7H195.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "FOUR_SHADOW_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    fill: "#273D7A",
    d: "M526,377.1l-17.5-125.2c-0.2-1.3-1.3-2.3-2.7-2.3h-23.6c-1.6,0-2.9,1.4-2.7,3.1l5.9,47.3 c0.2,1.9-1.2,3.5-3.1,3.5h-27c-1.7,0-3.1-1.3-3.2-3l-2.2-48.2c-0.1-1.5-1.3-2.6-2.7-2.6h-22c-1.6,0-2.8,1.3-2.7,2.8l3,82.4 c0.1,2.6,2.3,4.7,4.9,4.7h60.1l4.7,37.7H526z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "FOUR_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    fill: "#FF97C9",
    d: "M177.7,253.2l-13.2,149.6c-0.2,2.8-2.6,5-5.4,5h-19.8c-3.3,0-5.8-2.9-5.4-6.1l8.3-70.1 l-59.3,1c-3.3,0-5.8-2.9-5.2-6.1l0.2-1.3l13.6-72.9c0.4-2,2.1-3.5,4.2-3.5h18.9c2.6,0,4.6,2.4,4.2,5l-8.1,46 c-0.3,1.9,1.1,3.5,3,3.5h28.3l6.6-51.1c0.3-2,2-3.5,4-3.5h21.1C176,248.8,177.9,250.9,177.7,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    fill: "#F774B9",
    d: "M142.6,325.2l-0.5,6.4l-59.3,1c-3.3,0-5.8-2.9-5.2-6.1l0.2-1.3H142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    fill: "#F774B9",
    d: "M177.7,253.2l-13.2,149.6c-0.2,2.8-2.6,5-5.4,5h-3l15.7-159h1.9 C176,248.8,177.9,250.9,177.7,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    fill: "#F774B9",
    d: "M110.6,299.9c-0.3,1.9,1.1,3.5,3,3.5h-5.8c-2.1,0-3.8-1.9-3.4-4l8.9-50.5h1.3 c2.6,0,4.6,2.4,4.2,5L110.6,299.9z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "FOUR_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    fill: "#FF97C9",
    d: "M507.7,253.2l-13.2,149.6c-0.2,2.8-2.6,5-5.4,5h-19.8c-3.3,0-5.8-2.9-5.4-6.1l8.3-70.1 l-59.3,1c-3.3,0-5.8-2.9-5.2-6.1l0.2-1.3l13.6-72.9c0.4-2,2.1-3.5,4.2-3.5h18.9c2.6,0,4.6,2.4,4.2,5l-8.1,46 c-0.3,1.9,1.1,3.5,3,3.5h28.3l6.6-51.1c0.3-2,2-3.5,4-3.5h21.1C506.1,248.8,508,250.9,507.7,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    fill: "#F774B9",
    d: "M472.7,325.2l-0.5,6.4l-59.3,1c-3.3,0-5.8-2.9-5.2-6.1l0.2-1.3H472.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_139_",
    fill: "#F774B9",
    d: "M507.7,253.2l-13.2,149.6c-0.2,2.8-2.6,5-5.4,5h-3l15.7-159h1.9 C506.1,248.8,508,250.9,507.7,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    fill: "#F774B9",
    d: "M440.7,299.9c-0.3,1.9,1.1,3.5,3,3.5h-5.8c-2.1,0-3.8-1.9-3.4-4l8.9-50.5h1.3 c2.6,0,4.6,2.4,4.2,5L440.7,299.9z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "LIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    opacity: 0.28,
    fill: "#FF97C9",
    d: "M259.3,283.7l-20.5,104c-1.1,5.6,2.5,10.9,7.4,10.9h108.6 c4.8,0,8.4-5.1,7.5-10.5l-16.8-104c-0.7-4.2-3.8-7.2-7.5-7.2h-71.2C263.2,276.8,260.1,279.7,259.3,283.7z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "ORNAMENT_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    fill: "#FEC272",
    d: "M351.9,290.2l9.9,32.9c0.2,0.7,0.9,1.1,1.6,0.8l0,0c0.5-0.2,0.9-0.8,0.7-1.4l-6.5-33.7 c-0.4-1.8-2.4-2.8-4.1-2.1l0,0C352.2,287.3,351.5,288.7,351.9,290.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    fill: "#FEC272",
    d: "M333.2,302.1l6.4,25.4c0.1,0.5,0.6,0.7,1,0.6l0,0c0.4-0.1,0.6-0.5,0.5-0.9l-4.1-25.9 c-0.2-1.2-1.5-2-2.7-1.5l0,0C333.5,300.2,333,301.1,333.2,302.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    fill: "#FEC272",
    d: "M249.8,293.4l-8.3,25.3c-0.1,0.5-0.7,0.7-1.1,0.5l0,0c-0.4-0.2-0.6-0.6-0.5-1l6-25.9 c0.3-1.2,1.7-1.9,2.8-1.4h0C249.7,291.4,250.1,292.4,249.8,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    fill: "#FEC272",
    d: "M266.3,301.2l-10.8,47c-0.1,0.5-0.6,0.7-1,0.6l0,0c-0.4-0.1-0.6-0.5-0.5-0.9l8.5-47.5 c0.2-1.2,1.5-2,2.7-1.5l0,0C266.1,299.2,266.6,300.2,266.3,301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    fill: "#FEC272",
    d: "M289.2,306.7l-5.2,34.1c-0.1,0.5-0.6,0.8-1,0.6l0,0c-0.4-0.1-0.6-0.5-0.6-0.9l2.8-34.4 c0.2-1.2,1.4-2,2.6-1.6l0,0C288.8,304.7,289.4,305.7,289.2,306.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    fill: "#FEC272",
    d: "M316,306l1.3,54.1c0,0.5-0.4,0.8-0.9,0.8l0,0c-0.4-0.1-0.7-0.4-0.7-0.8L312,306 c0-1.3,1.1-2.2,2.3-2l0,0C315.3,304.2,316,305.1,316,306z"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "SPACESHIP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    fill: "#738DE0",
    d: "M212.1,256.9c-1.1-1.3-1.9-2.6-2.5-3.9l-2.3-15.4l5.3,4.9L212.1,256.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    fill: "#273D7A",
    d: "M361.3,262.1c0,0-3.3,6.9-10.5,14.6c-9,9.6-24.2,20.5-46.8,20.5 c-15.9,0-27.7-5.3-36.1-11.7c-13.2-10-18.4-22.8-18.4-22.8L361.3,262.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    fill: "#072359",
    d: "M361.3,262.1c0,0-3.3,6.9-10.5,14.6c-7.7,3-17.2,5.5-29,7.1c-23.2,3.1-41.3,2.9-53.9,1.7 c-13.2-10-18.4-22.8-18.4-22.8L361.3,262.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    fill: "#99ADF9",
    d: "M396.5,237c0,0-0.6,6.3-2.6,14.1c-0.3,1.1-0.8,2.4-1.6,3.6c-2.1,3.4-6.1,7.1-12.6,10.6 c-1.1,0.6-2.4,1.2-3.7,1.8c-1,0.5-2,0.9-3.1,1.4c-1.5,0.6-3,1.2-4.6,1.8c-5.6,2-12.2,3.7-20,5.3c-0.6,0.1-1.1,0.2-1.7,0.3 c-1.5,0.3-3.3,0.5-5.2,0.7c-8,0.9-18.6,1.5-29.9,1.7c-2.1,0-4.2,0.1-6.3,0.1c-10.7,0.1-21.5-0.2-30.9-0.7c-2-0.1-4-0.2-5.8-0.4 c-5.5-0.4-10.3-1-13.8-1.7c-5.1-1-9.7-2.1-13.8-3.3c-1.7-0.5-3.3-1-4.9-1.5c-12.4-4.1-19.9-9.1-23.8-13.7c-0.6-0.7-1.1-1.3-1.5-2 c-0.4-0.6-0.8-1.3-1-1.9c-0.3-0.7-0.6-1.3-0.7-2c-0.9-3.7-1.6-7.5-1.9-10.4c-0.4-3.3-0.5-5.5-0.5-5.5l95,7.1l95-5.3L396.5,237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_209_",
    fill: "#273D7A",
    d: "M396.4,236.8C396.4,236.8,396.4,236.8,396.4,236.8c0,0.7-0.5,1.6-1.4,2.7 c-2.5,2.9-8.5,7.2-18.7,11.1c-1.3,0.5-2.7,1-4.2,1.5c-0.7,0.2-1.4,0.5-2.1,0.7c-1.5,0.5-3.1,1-4.8,1.4h0 c-5.7,1.6-12.3,3.1-19.9,4.2c-1.8,0.3-3.7,0.6-5.7,0.8c-8.4,1.1-17.8,1.8-28.3,2c-2,0-4.1,0.1-6.2,0.1H305 c-10.7,0-20.6-0.5-29.5-1.3c-2-0.2-4-0.4-5.9-0.6c-9.8-1.1-18.5-2.7-26-4.5c-1.7-0.4-3.4-0.9-5-1.3c-14.9-4.1-24.7-9.2-29.2-13.4 c-0.9-0.8-1.6-1.7-2.1-2.4c-0.6-0.9-0.9-1.7-0.9-2.5c0-7.1,28-22.2,99.1-22.2C376.6,213,396.4,231.9,396.4,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    fill: "#072359",
    d: "M264.5,221.2l-52,21.3c-2-1.3-4.8-4.1-5.3-4.9l55.6-17.3L264.5,221.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    fill: "#072359",
    d: "M396.4,236.9c0,0.6-0.5,1.5-1.4,2.6l-53.4-18.3l1.7-0.8L396.4,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    fill: "#072359",
    d: "M273.3,226.7l-29.7,28.1c-1.7-0.4-3.4-0.9-5-1.3l32.9-26.9L273.3,226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    fill: "#072359",
    d: "M289.6,230l-14.1,30c-2-0.2-4-0.4-5.9-0.6l18.2-29.5L289.6,230z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    fill: "#072359",
    d: "M345.4,258.5c-1.8,0.3-3.8,0.6-5.7,0.8L325.9,230l1.9-0.1L345.4,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    fill: "#072359",
    d: "M311.3,261.3c-2,0-4.1,0.1-6.2,0.1H305l2.4-29.5l1.9-0.1L311.3,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_207_",
    fill: "#072359",
    d: "M376.2,250.6c-1.3,0.5-2.7,1-4.2,1.5l-35.9-25.4l1.9-0.1L376.2,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    fill: "#738DE0",
    d: "M311.4,278.1c-2.1,0-4.2,0.1-6.3,0.1v-16.9l6.2-0.1L311.4,278.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    fill: "#738DE0",
    d: "M346.4,275.7c-1.6,0.3-3.3,0.5-5.2,0.7l-1.6-17.2l5.7-0.8L346.4,275.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_205_",
    fill: "#738DE0",
    d: "M379.6,265.2c-1.1,0.6-2.4,1.2-3.7,1.8l-3.8-15l4.1-1.4L379.6,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    fill: "#738DE0",
    d: "M275.5,260l-1.2,17.5c-2-0.1-4-0.2-5.8-0.4l1.2-17.7L275.5,260z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    fill: "#738DE0",
    d: "M243.6,254.8l-2.8,17.3c-1.7-0.5-3.3-1-4.9-1.5l2.6-17.1L243.6,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    fill: "#738DE0",
    d: "M212.6,242.7l-2,12.3c-0.4-0.6-0.8-1.3-1-1.9c-0.3-0.7-0.6-1.3-0.7-2 c-0.9-3.7-1.6-7.5-1.9-10.4l0.3-3c0,0,1.7,2,2.4,2.7C210.3,241,212.6,242.7,212.6,242.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1_",
    fill: "#072359",
    cx: 300.8,
    cy: 228.7,
    rx: 53.3,
    ry: 15.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    fill: "#99ADF9",
    d: "M349.5,226.3c0,0-3.9,4.4-13.5,8.2c-7.1,2.8-17.3,5.2-31.3,5.2c-7.7,0-14.4-0.7-20-1.8 c-18.7-3.6-26.8-11.4-26.8-11.4s4.1-30.4,29.7-40.7c5.2-2.1,11.4-3.4,18.6-3.4C341.4,182.4,349.5,226.3,349.5,226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    fill: "#7A97F4",
    d: "M284.7,237.9c-18.7-3.6-26.8-11.4-26.8-11.4s4.1-30.4,29.7-40.7 c-5,4.2-9.9,12.6-10.7,26.3C276.1,222.3,278.5,230.8,284.7,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    fill: "#C2D1FF",
    d: "M349.5,226.3c0,0-3.9,4.4-13.5,8.2c-1.5-5.6-3.8-10.6-3.8-10.6s-9.4,2-13.6-6.9 c-4.2-8.9,5.9-15.3,5.9-15.3s-2.4-7.7-14.8-12.7c-12.4-5-22.3-3.2-22.3-3.2c5.2-2.1,11.4-3.4,18.6-3.4 C341.4,182.4,349.5,226.3,349.5,226.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_11_",
    fill: "#C2D1FF",
    cx: 309.2,
    cy: 204.9,
    rx: 2.7,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_21_",
    fill: "#C2D1FF",
    cx: 299.8,
    cy: 208,
    rx: 2.1,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_20_",
    fill: "#C2D1FF",
    cx: 306.1,
    cy: 219.5,
    rx: 4.1,
    ry: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.10eee2563c8758417d623d8d827a8fea.svg";
export { ForwardRef as ReactComponent };